module.exports = __webpack_public_path__ + "a72f63fc4001c2773780671439fda50b.png";